import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from '../Models/response.model';
import { HttpCallService } from '../shared/services/base.service';
import { AppConstant } from '../app.constants';

@Injectable()
export class SiteLayoutService {

    constructor(private _dataService: HttpCallService,
        private _appConstant: AppConstant) { }

    getUserProgramDetails(): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'Program/GetProgramDetailByUser/' + this._appConstant.userDetail.userId + '/' + this._appConstant.userDetail.userId;
        return this._dataService.get<IResponse>(apiURL);
    }

    getUserModuleAccess(): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'ProgramUser/GetModuleDetailByProgramId/' + this._appConstant.programId + '/' + this._appConstant.userDetail.userId;
        return this._dataService.get<IResponse>(apiURL);
    }

    getLogInAsProgramContextModuleAccess(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'ProgramSubscription/GetSubscription/'
        return this._dataService.get<any>(apiURL + data);
    }

    GetInsightMenu(data:number): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'Program/GetInsightMenu/'
        return this._dataService.get<IResponse>(apiURL+data);
    }

    getProgramDataSource(data?: string): Observable<IResponse> {
        // Change URL for getting All program list ( Active / InActive )
        //const apiURL = this._appConstant.APIUrl + 'LookUp/GetPrograms';
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetAdminPrograms';
        return this._dataService.get<IResponse>(apiURL);
    }

    getAppsettings() : Observable<IResponse>{
        const apiURL = this._appConstant.MIMSAPIUrl + 'resources/appsettings';
      return this._dataService.get<IResponse>(apiURL);
      }


}
